<template>
  <div :class="{ [step]: !!step }" class="reset-pwd" style="background-color: #fff">
    <!-- <div class="title">系统登录</div> -->
    <div class="title" style="padding: 15px 0px 5px 0px" xs12>
      <div style="width: 100%; height: 52px; text-align: center">
        <img style="width: 50px; height: 50px" @click="addClickTimes()" src="imgs/svg/my/logo.png" />
      </div>
      <div style="text-align: center; margin-top: 30px">
        <span class="login_span">{{ $t('重置密码') }}</span>
      </div>
    </div>
    <template v-if="step === 'enter-account'">
      <div style="margin-left: 7.5%; margin-top: 38px">{{ $t('请输入手机号或邮箱地址：') }}</div>
      <v-text-field name="phoneNumber" style="width: 85%; margin-left: 7.5%" flat :label="$t('手机号/邮箱地址')" single-line
        validate-on-blur :rules="[rules.phoneRequired, rules.phoneMatch]" v-model="phoneNumber" ref="phoneNumber"
        tabindex="1" required clearable type="text" autocomplete="off" @keydown="focus2next()"></v-text-field>
      <v-flex style="width: 90%; margin-left: 5%; margin-top: 10px">
        <v-btn :loading="loading" tabindex="2" class="login" color="primary" @click="onNext">{{ $t('下一步?') }}</v-btn>
      </v-flex>
    </template>
    <template v-else-if="step === 'enter-vcode'">
      <div style="margin-left: 7.5%; margin-top: 38px">
        {{ $t('验证短信已发送至{phoneNumber},请输入验证码：', {
          phoneNumber: phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
        })
        }}
      </div>
      <v-text-field ref="vcode" name="vcode" style="width: 85%; margin-left: 7.5%" flat :label="$t('验证码')" single-line
        validate-on-blur v-model="vcode" :rules="[rules.vcodeRequired]" type="number" required clearable tabindex="3"
        @keydown="focus2next()"></v-text-field>
      <div style="margin-right: 7.5%; margin-top: 0; margin-bottom: 10px; float: right">{{ $t('没有收到?') }}
        <span v-if="countDown" style="margin-right: 8px">{{ $t('{number}秒后', { number: countDown }) }} </span>
        <v-btn :disabled="loading || loading2 || !!countDown" flat tabindex="4" color="primary"
          style="margin: 0; padding: 0; min-width: auto" @click="sentVcode">{{ $t('再次发送') }}</v-btn>
      </div>
      <v-flex style="width: 90%; margin-left: 5%; margin-top: 10px">
        <v-btn :loading="loading" tabindex="5" class="login" color="primary" @click="onNext">{{ $t('下一步') }}</v-btn>
      </v-flex>
    </template>
    <template v-else-if="step === 'enter-password'">
      <div style="margin-left: 7.5%; margin-top: 38px; margin-bottom: 10px">{{ $t('请输入新密码和确认密码：') }}</div>
      <v-text-field style="width: 85%; margin-left: 7.5%" flat :label="$t('请输入密码')" single-line validate-on-blur
        :rules="[rules.pswRequired, rules.pswComplexityRqmt]" v-model="password" ref="password" required clearable
        type="password"></v-text-field>
      <v-text-field style="width: 85%; margin-left: 7.5%" flat :label="$t('确认密码')" single-line validate-on-blur
        :rules="[rules.pswConfirmRequired, rules.pswConfirmMustBeSame]" v-model="passwordCertain" ref="passwordCertain"
        required clearable type="password" @keydown="focus2next()"></v-text-field>
      <v-flex style="width: 90%; margin-left: 5%; margin-top: 10px">
        <v-btn :loading="loading" tabindex="2" class="login" color="primary" @click="onNext">{{ $t('提交') }}</v-btn>
      </v-flex>
    </template>
    <template v-else-if="step === 'email-tips'">
      <div style="margin-left: 7.5%; margin-top: 38px; margin-bottom:20px">
        {{ $t('验证邮件已发送至{phoneNumber}，请打开邮件验证邮箱账号，完成密码重置。', { phoneNumber: phoneNumber }) }}
      </div>
      <v-flex style="width: 90%; margin-left: 5%">
        <v-btn :loading="loading" tabindex="6" class="login" color="primary" @click="onNext">{{ $t('返回登录') }}</v-btn>
      </v-flex>
    </template>

    <eds-copyright v-if="platform === 'browser'" :beian="true" />
  </div>
</template>

<script>
import edsCopyright from './edsCopyright'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import axios from 'axios'
import msgbus from '../msgBus'
import operations from '../operations'
import funcListConfig from '../funcListConfig'
import dbHelper from '../util/db'
import debugHelper from '../util/debug'
import tools from '../util/tools'
import { URLS } from '../util/urls'
import isTest from '../util/urltest'

export default {
  name: 'iDS-ResetPwd',
  components: {
    edsCopyright
  },
  data: function () {
    return {
      phoneNumber: '',
      vcode: '',
      password: '',
      passwordCertain: '',
      loading: false,
      loading2: false,
      rules: {
        phoneRequired: (v) => !!v || this.$t('请输入手机号或邮箱地址'),
        vcodeRequired: (v) => !!v || this.$t('请输入验证码'),
        phoneMatch: (phone) =>
          /^1\d{10}$/.test(phone) ||
          /^((?:\w+-*\.?)+)@((?:\w+-*)+(\.(?:\w+-*))+)+$/.test(phone) ||
          this.$t('请输入正确的手机号或邮箱地址'),
        pswRequired: (v) => !!v || this.$t('请输入密码'),
        pswConfirmRequired: (v) => !!v || this.$t('请再次输入密码'),
        pswComplexityRqmt: v =>
          /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W]+$)\S{8,32}$/.test(v) ||
          this.$t('密码需包含“大写字母、小写字母、数字、特殊符号”中两种以上的组合，且长度在8到32位'),
        pswConfirmMustBeSame: v =>
          (!!v && v == this.password) || this.$t('两次输入密码不一致')
      },
      isTest: isTest,
      step: 'enter-account', // enter-account\enter-vcode\enter-password\email-tips
      countDown: 0,
    }
  },

  computed: {
    ...mapGetters('app', [
      'platform',
    ]),
    form() {
      if (this.step === 'enter-account') {
        return {
          phoneNumber: this.phoneNumber,
        }
      } else if (this.step === 'enter-vcode') {
        return {
          vcode: this.vcode,
        }
      } else if (this.step === 'enter-password') {
        return {
          password: this.password,
          passwordCertain: this.passwordCertain,
        }
      } else {
        return {}
      }
    },
  },

  watch: {
    step: function (newVal, oldVal) {
      this.$nextTick(() => {
        this.formValidate(true)
      })
    }
  },

  methods: {
    mSetParams(funcList) {
      var func = funcList[0]
      switch (func.id) {
        case operations.eCreateBottomsByRoles:
          func.params.roles = msgbus.vm.getUserRoles()
          break
      }
      return funcList
    },
    mGetResult(funcList) {
      var func = funcList[0]
      return funcList
    },

    go2body() {
      setTimeout(function () {
        document.getElementsByTagName('body')[0].scrollTop = 0
      }, 500)
    },

    formValidate(intelligent = false) {
      Object.keys(this.form).forEach(prop => {
        const ref = this.$refs[prop]
        const val = this[prop]
        if (ref) {
          if (intelligent) { // 先重置校验结果，再校验有值项
            ref.resetValidation()
            if (val) {
              setTimeout(() => {
                ref.validate(true)
              }, 100)
            }
          } else {
            ref.validate(true)
          }
        }
      })
    },

    onNext() {
      if (this.step === 'enter-account') {
        if (['phoneNumber'].some(f => !this.$refs[f].validate(true))) {
          return
        }
        if (/^1\d{10}$/.test(this.phoneNumber)) {
          this.loading = true
          this.go2body()
          axios({
            method: 'post',
            url: URLS.EDS_VCODE_URL,
            data: {
              mobileNo: this.phoneNumber,
            },
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then((resp) => {
              this.step = 'enter-vcode'
              this.onCountDown()
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              debugHelper.log(err)
              err.type = 'error'
              err.prefix = 'vcode:'
              tools.showTips(msgbus.vm, err)
              return
            })
        } else {
          this.loading = true
          this.go2body()
          axios({
            method: 'post',
            url: URLS.EDS_SENT_VEMAIL_URL,
            data: {
              email: this.phoneNumber,
              lang: 'zh',
            },
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then((resp) => {
              this.loading = false
              this.step = 'email-tips'
            })
            .catch((err) => {
              this.loading = false
              debugHelper.log(err)
              err.type = 'error'
              err.prefix = 'vemail:'
              tools.showTips(msgbus.vm, err)
              return
            })
        }
      } else if (this.step === 'enter-vcode') {
        if (['vcode'].some(f => !this.$refs[f].validate(true))) {
          return
        }
        this.loading = true
        this.go2body()
        msgbus.vm
          .fetchAuthToken({
            data: {
              mobileNo: this.phoneNumber,
              password: '',
              vcode: this.vcode,
            },
            noCommit: true,
            vm: msgbus.vm,
          })
          .then(
            (data) => {
              this.loginSuccess = data

              this.loading = false
              this.step = 'enter-password'
            },
            () => {
              this.loading = false
              return
            }
          )
      } else if (this.step === 'enter-password') {
        if (['password', 'passwordCertain'].some(f => !this.$refs[f].validate(true))) {
          return
        }
        msgbus.vm
          .updateUserPwd({
            authorization: {
              Authorization: 'Bearer ' + this.loginSuccess.token,
            },
            data: {
              mobileNo: this.phoneNumber,
              password: '',
              newPassword: this.password,
              vcode: this.vcode,
            },
            vm: msgbus.vm,
          })
          .then(
            () => {
              msgbus.vm.setLoginSuccess({ value: this.loginSuccess })

              msgbus.vm.setIsPwd({ value: false })
              msgbus.vm.setRegcode({ value: this.vcode })

              // 初始化系统
              tools.startFuncList(
                msgbus,
                this,
                funcListConfig.common.initAfterLogin
              )

              msgbus.vm.setSnackBar({
                value: {
                  color: 'success',
                  text: this.$t('密码设置成功'),
                  visible: true,
                },
              })

              // 标识重置密码了，以便刷新登录时不弹重置密码，注意：退出登录时，该标识会清空
              dbHelper.set('haveResetPwd', '')

              //跳转页面
              msgbus.vm.setBottomNavVisible(true)
              msgbus.vm.setBottomActiveBtn({
                value: msgbus.vm.getBottomNavButtons()[0].name,
              })
              this.$router.replace({
                name: msgbus.vm.getBottomNavButtons()[0].click.params,
              })
            },
            () => {
              msgbus.vm.setSnackBar({
                value: {
                  color: 'error',
                  text: this.$t('密码设置失败'),
                  visible: true,
                },
              })
              return
            }
          )
      } else if (this.step === 'email-tips') {
        this.$router.replace({ name: 'pwdlogin' })
      }
    },

    focus2next() {
      if (event.keyCode == 13) {
        this.onNext()
      }
    },

    sentVcode() {
      this.loading2 = true
      this.go2body()
      axios({
        method: 'post',
        url: URLS.EDS_VCODE_URL,
        data: {
          mobileNo: this.phoneNumber,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((resp) => {
          this.onCountDown()
          this.loading2 = false
        })
        .catch((err) => {
          this.loading2 = false
          debugHelper.log(err)
          err.type = 'error'
          err.prefix = 'vcode:'
          tools.showTips(msgbus.vm, err)
          return
        })
    },

    onCountDown() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = undefined
      }
      this.countDown = 60
      this.interval = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--
        }
      }, 1000)
    },

    changeView() {
      msgbus.vm.setTitle('')
      msgbus.vm.setBackDisabled(true)
      msgbus.vm.setBackIcon('')
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setMsgInputVisible({ value: false })

      if (!this.phoneNumber) {
        document.getElementsByName('phoneNumber')[0].focus()
      }
    },
  },
  created() {
    // 若是“软件许可与服务协议”页面返回，则先判断是否有手机号/验证码的设置信息
    this.phoneNumber = msgbus.vm.getPhoneNumber()
    this.step = 'enter-account'
  },
  mounted() {
    this.changeView()
  },
}
</script>

<style lang="scss">
.reset-pwd {

  h1:first-child {
    width: 100%;
    text-align: center;
    margin-top: -100px;
    margin-bottom: 12px;
  }

  .v-input__slot {
    margin-bottom: 0px;
    border-width: thin;
  }

  .v-text-field {
    margin-bottom: 2px;
  }

  .v-text-field__details {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  button.v-btn.login {
    width: calc(100% - 16px);
  }

  .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
    background-color: #ffffff;
    border: 1px solid rgb(48, 133, 214);
  }

  .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: #ffffff !important;
    border: 1px solid #d7d7d7 !important;
    color: #d7d7d7 !important;
  }

  .login_span {
    font-family: PingFangSC-Medium;
    font-size: 30px;
    font-weight: bold;
    color: #505050;
    letter-spacing: 0;
    text-align: center;
  }

  .v-label {
    font-size: 14px;
  }

  .primary {
    background-color: rgb(48, 133, 214) !important;
    border-color: rgb(48, 133, 214) !important;
  }

  input {
    margin-top: 0px !important;
    padding: 6px 0;
  }

  &>.eds-copyright {
    position: absolute;
    bottom: 0;
  }
}

@media screen and (max-height: 470px) {
  .reset-pwd.enter-account {
    &>.eds-copyright {
      position: relative;
      margin-top: 10px;
    }
  }
}

@media screen and (max-height: 510px) {
  .reset-pwd.enter-vcode {
    &>.eds-copyright {
      position: relative;
      margin-top: 10px;
    }
  }
}

@media screen and (max-height: 540px) {
  .reset-pwd.enter-password {
    &>.eds-copyright {
      position: relative;
      margin-top: 10px;
    }
  }
}
</style>
